interface NavigatorWithConnection extends Navigator {
  connection?: any;
  mozConnection?: any;
  webkitConnection?: any;
}

export function getConnectionInfo() {
  const nav = navigator as NavigatorWithConnection | undefined;
  return nav?.connection || nav?.mozConnection || nav?.webkitConnection;
}
